<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <div class="section-one part-header">
      <div class="nav-bar nav-bar-black">
        <div class="nav-bar_label">Housekeeper service</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>班管家服务</span>班管家系统配置
        </div>
        <!-- <img src="../../img/service2/nav-top.png" class="product service2" /> -->
      </div>

      <div class="pic">
        <img src="../../img/service2/pic-1.png" class="" />
      </div>
    </div>

    <div class="section-one part-white">
      <div class="pic-2">
        <img src="../../img/service2/pic-2.png" class="" />
      </div>
    </div>
    <div class="section-one part-gray">
      <div class="pic-3">
        <img src="../../img/service2/pic-3.png" class="" />
      </div>
    </div>
    <div class="section-one part-white">
      <div class="pic-4">
        <img src="../../img/service2/pic-4.png" class="" />
      </div>
    </div>
    <div class="section-one part-gray part-last">
      <div class="pic-5">
        <img src="../../img/service2/pic-5.png" class="" />
      </div>
    </div>

    <Footer />

  </div>

</template>

<script>
// idmport $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    // $('.nav-btm-line').css({
    //   left: 220 + 'px'
    // });
  }
};
</script>

<style scoped lang="less">
.part-header {
  background-color: #EFEFEF;
  height: 1088px;
  .pic {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 130px;
    width: 1101px;
    height: 783px;
    margin: 0 auto;
    img {
        width: 100%;
        height: 100%;
    }
  }
}
// .part-white1 {
//   background-color: #FFF;
//   padding: 115px 0;
//   .pic {
//     width: 1105px;
//     height: 614px;
//     margin: 0 auto;
//     img {
//         width: 100%;
//         height: 100%;
//     }
//   }
// }
.part-gray {
  background-color: #EFEFEF;
  padding: 115px 0;
  img {
      width: 100%;
      height: 100%;
  }
  .pic-3 {
    width: 1100px;
    // height: 988px;
    margin: 0 auto;
  }
  .pic-5 {
    width: 1100px;
    // height: 634px;
    margin: 0 auto;
    
  }
  &.part-last {
    padding-bottom: 200px;
  }
}
.part-white {
  background-color: #FFF;
  padding: 115px 0;
  img {
      width: 100%;
      height: 100%;
  }
  .pic-2 {
    width: 1100px;
    // height: 614px;
    margin: 0 auto;
  }
  .pic-4 {
    width: 1100px;
    // height: 660px;
    margin: 0 auto;
  }
}
</style>